<app-assessments-mirror-header></app-assessments-mirror-header>
<app-modal-body-assessments-mirror
  [userId]="userId"
  [userName]="userName"
  [evaluationUuid]="evaluationUuid"
></app-modal-body-assessments-mirror>
